module.exports = __webpack_public_path__ + "img/scan (18).0eb2c30a.png";